export default __webpack_public_path__ + "static/Bild - Wir würden dich gerne kennenlernen-257a65721fb021e904e12bc3468638e9.jpg";